<template>
  <div class="costOriginValue">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">资产原值</div>
        <div class="select-container">
          <div class="select-container-box">
            <span>查找&nbsp;&nbsp;</span>
            <el-input placeholder="请输入资产名称"  v-model="keyword" prefix-icon="el-icon-search" size="small" type="text" :maxlength="20" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" class="search-input" clearable>
            </el-input>
          </div>
          <div class="select-container-box"  v-if="canEditAll=true">
            <el-button size="small" type="info" plain  class="query" @click="search">查询</el-button>
            <el-button size="small" type="info" plain  class="add" @click="add" v-if="edit">添加</el-button>
          </div>
        
        </div>
      </div>
      <div class="table-container">
        <el-table
          :data="planList"
          style="width:100%" 
          :row-class-name="rowClassName"
          size="medium" 
          :default-sort="{prop: 'date', order: 'descending'}">
            <i slot="empty" style="font-style:normal">该时间段暂无数据</i>
          <el-table-column
            prop="dataDate" 
            label="登记日期"
            width="108" 
            align="center"
            show-overflow-tooltip 
          >
            <template slot-scope="scope">
              <el-date-picker
                v-model="scope.row.dataDate"
                :clearable="false"
                @change="calculation(scope.$index,scope.row)"
                value-format="yyyy-MM-dd"
                :picker-options="pickerTimeOptions"
                type="date"
                >
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column 
          prop="fishBaseId" 
          label="基地" 
          show-overflow-tooltip
          width="145"
          align="center">
           <template slot-scope="scope">
              <el-select v-model="scope.row.fishBaseId" placeholder="">
                <el-option
                  v-for="item in baseList"
                  :key="item.id"
                  :label="item.value"
                  :value="item.key">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column 
          prop="typeId" 
          label="类型"
          width="110"
          show-overflow-tooltip 
          align="center">
            <template slot-scope="scope">
              <el-select v-model="scope.row.typeId" placeholder="">
                <el-option
                  v-for="item in typeList"
                  :key="item.id"
                  :label="item.value"
                  :value="item.key">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column 
          prop="assetName" 
          label="资产名称"
          width="135"
          show-overflow-tooltip 
          align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.assetName" :maxlength="20"></el-input>
            </template>
          </el-table-column>
          <el-table-column 
          prop="originalCost" 
          label="原值(元)" 
          show-overflow-tooltip 
          align="center">
            <template slot-scope="scope">
              <el-input @input="calculation(scope.$index,scope.row)" v-model="scope.row.originalCost" type="number"></el-input>
            </template>
          </el-table-column>
          <el-table-column 
          prop="salvage" 
          label="残值率"
          width="70" 
          show-overflow-tooltip 
          align="center">
            <template slot-scope="scope">
              <el-input @input="calculation(scope.$index,scope.row)" v-model="scope.row.salvage" type="number"></el-input>
            </template>
          </el-table-column>
          <el-table-column 
          prop="salvageCost" 
          label="残值" 
          show-overflow-tooltip 
          align="center">
            <template slot-scope="scope">
              <el-input @input="calculation(scope.$index,scope.row)" readonly v-model="scope.row.salvageCost" type="number"></el-input>
            </template>
          </el-table-column>
          <el-table-column 
          prop="satrtTime" 
          label="开始使用日期"
          show-overflow-tooltip
          width="108"  
          align="center">
            <template slot-scope="scope">
              <el-date-picker
                v-model="scope.row.satrtTime"
                :clearable="false"
                @change="calculation(scope.$index,scope.row)"
                value-format="yyyy-MM-dd"
                type="date"
                >
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column 
          prop="endTime" 
          label="结束使用日期"
          show-overflow-tooltip
           width="108"   
          align="center">
            <template slot-scope="scope">
              <el-date-picker
                v-model="scope.row.endTime"
                :clearable="false"
                @change="calculation(scope.$index,scope.row)"
                value-format="yyyy-MM-dd"
                type="date"
                >
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column 
          prop="oldTotalMonth" 
          label="总折旧月数"
          width="90"
          show-overflow-tooltip  
          align="center">
             <template slot-scope="scope">
              <el-input @input="calculation(scope.$index,scope.row)" readonly v-model="scope.row.oldTotalMonth" type="number"></el-input>
            </template>
          </el-table-column>
            <el-table-column 
          prop="provisionTime" 
          label="开始计提日期"
          show-overflow-tooltip
          width="108" 
          align="center">
            <template slot-scope="scope">
              <el-date-picker
                v-model="scope.row.provisionTime"
                :clearable="false"
                 @change="calculation(scope.$index,scope.row)"
                value-format="yyyy-MM-dd"
                type="date"
                >
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column 
          prop="hasOldMonth" 
          show-overflow-tooltip 
          label="已折旧月数"
          width="90"
          align="center">
            <template slot-scope="scope">
              <el-input readonly  @input="calculation(scope.$index,scope.row)" v-model="scope.row.hasOldMonth" type="number"></el-input>
            </template>
          </el-table-column>
          <el-table-column 
          prop="oldTotalMoney" 
          label="累计已折旧(元)" 
          width="115"
          show-overflow-tooltip 
          align="center">
           <template slot-scope="scope">
              <el-input readonly @input="calculation(scope.$index,scope.row)" v-model="scope.row.oldTotalMoney" type="number"></el-input>
            </template>
          </el-table-column>
          <el-table-column 
          prop="ownerId" 
          show-overflow-tooltip 
          label="登记人" 
          width="115"
          align="center">
            <template slot-scope="scope">
              <el-select v-model="scope.row.ownerId" placeholder="" @change="changeOwner(scope.$index,scope.row)">
                <el-option
                  v-for="item in peopleList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="操作栏" align="center" width="100">
            <template slot-scope="scope">
              <span
                @click="handleEdit(scope.$index, scope.row)" class="content-edit">{{edit?scope.row.edit:"查看"}}</span>
              <span
                @click="handleDelete(scope.$index, scope.row)" class="content-del" v-if="edit">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <page-change :pageInfo="pageInfo"></page-change>
    </div>
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";
import { modules } from "../../../store";
import PageChange from "../../common/PageChange";
import mixins from "@/common/MixIn.js";
export default {
  name: "costOriginValue",
  mixins: [mixins],
  components: {
    PageChange
  },
  data() {
    return {
      obj: {},
      once: true, //是否第一次添加
      ownerName: "",
      baseList: [],
      peopleList: [],
      typeList: [
        {
          key: 1,
          value: "池塘租金"
        },
        {
          key: 2,
          value: "设备"
        }
      ],
      keyword: "",
      // 分页
      pageInfo: {
        pageNumber: 1, // 当前页数
        totalPages: 0, // 总页数
        pageFunc: this.search, // 当前页数需要调用的函数
        pageSize: 10 // 当前页数
      },
      pickerTimeOptions: {
        // 限制日期
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },
      list: []
    };
  },
  computed: {
    planList() {
      return this.list.map(item => {
        if (!item.edit) {
          item.edit = "编辑";
        }
        return item;
      });
    }
  },
  async mounted() {
    this.search();
  },
  methods: {
    ...mapActions(modules.base, {
      getBaseList: "getBaseList" //基地
    }),
    ...mapActions(modules.user, ["getEmployees"]), //获取登记人数据
    ...mapActions(modules.costOriginValue, [
      "getCostOriginValueList",
      "addCostOriginValue",
      "deleteCostOriginValue",
      "updateCostOriginValue"
    ]),
    //获取登记人名字
    changeOwner(index, row) {
      let item = this.peopleList.find(f => f.id == row.ownerId);
      this.ownerName = item.name;
    },
    //初始化列表数据 ,查询列表
    async search() {
      await this.getCostOriginValueList({
        queryString: this.keyword,
        pageIndex: this.pageInfo.pageNumber,
        pageSize: this.pageInfo.pageSize
      })
        .then(async data => {
          this.list = data.list;
          this.pageInfo.totalPages = data.total;
          this.baseList = await this.getBaseList();
          this.peopleList = await this.getEmployees();
        })
        .catch(err => {
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error"
          });
        });
    },
    addProductionPlan(index, row) {
      this.$set(this.list, index, {
        edit: "编辑",
        id: row.id,
        fishBaseId: row.fishBaseId,
        typeId: row.typeId,
        ownerId: row.ownerId,
        assetName: row.assetName,
        satrtTime: row.satrtTime,
        endTime: row.endTime,
        oldTotalMonth: this.oldTotalMonthtotal(row), //总折旧月数
        dataDate: row.dataDate, //登记日期
        provisionTime: row.provisionTime, //开始计提日
        hasOldMonth: this.hasOldMonthTotal(row), //期初已折旧月数
        originalCost: row.originalCost, //原值
        salvage: row.salvage, //残值率
        salvageCost: this.salvageCostTotal(row), //残值
        oldTotalMoney: this.money(row) // 计折旧金额
      });
      row.ownerName = this.ownerName;
      this.addCostOriginValue([row])
        .then(async data => {
          this.$message.success("保存成功");
          this.once = true;
          this.search();
        })
        .catch(err => {
          // this.once = false;
          // this.$set(this.list, index, {
          //   edit: "保存",
          //   fishBaseId: row.fishBaseId,
          //   typeId: row.typeId,
          //   ownerId: row.ownerId,
          //   assetName: row.assetName,
          //   satrtTime: row.satrtTime,
          //   endTime: row.endTime,
          //   oldTotalMonth: this.oldTotalMonthtotal(row), //总折旧月数
          //   dataDate: row.dataDate, //登记日期
          //   provisionTime: row.provisionTime, //开始计提日
          //   hasOldMonth: this.hasOldMonthTotal(row), //期初已折旧月数
          //   originalCost: row.originalCost, //原值
          //   salvage: row.salvage, //残值率
          //   salvageCost: this.salvageCostTotal(row), //残值
          //   oldTotalMoney: this.money(row) // 计折旧金额
          // });
          // row.ownerName = this.ownerName;
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error"
          });
        });
    },
    editProductionPlan(index, row) {
      console.log(row);
      this.changeOwner(index, row);
      this.obj = {
        edit: "编辑",
        fishBaseId: row.fishBaseId,
        typeId: row.typeId,
        ownerId: row.ownerId,
        assetName: row.assetName,
        satrtTime: row.satrtTime,
        endTime: row.endTime,
        oldTotalMonth: this.oldTotalMonthtotal(row), //总折旧月数
        dataDate: row.dataDate, //登记日期
        provisionTime: row.provisionTime, //开始计提日
        hasOldMonth: this.hasOldMonthTotal(row), //期初已折旧月数
        originalCost: row.originalCost, //原值
        salvage: row.salvage, //残值率
        salvageCost: this.salvageCostTotal(row), //残值
        oldTotalMoney: this.money(row) // 计折旧金额
      };
      let nameReg = /^[\u4e00-\u9fa5a-zA-Z0-9]+$/;
      if (!nameReg.test(this.obj.assetName) || this.obj.assetName == "") {
        this.$message.error("请输入正确的资产名称且不为空");
        return;
      }
      let originalCostReg = /^[1-9]\d*$/;
      if (
        !originalCostReg.test(this.obj.originalCost) ||
        this.obj.originalCost == ""
      ) {
        this.$message.error("原值必须大于0且不为空");
        return;
      }
      let salvageReg = /^(0.\d+|0|1)$/;
      if (!salvageReg.test(this.obj.salvage) || this.obj.salvage === "") {
        this.$message.error("残值率范围：0-1且不为空");
        return;
      }
      this.updateCostOriginValue({
        id: row.id,
        obj: this.obj
      })
        .then(async data => {
          this.$message.success("保存成功");
          this.list.splice(index, 1, {
            id: row.id,
            edit: "编辑",
            fishBaseId: row.fishBaseId,
            typeId: row.typeId,
            ownerId: row.ownerId,
            assetName: row.assetName,
            satrtTime: row.satrtTime,
            endTime: row.endTime,
            oldTotalMonth: this.oldTotalMonthtotal(row), //总折旧月数
            dataDate: row.dataDate, //登记日期
            provisionTime: row.provisionTime, //开始计提日
            hasOldMonth: this.hasOldMonthTotal(row), //期初已折旧月数
            originalCost: row.originalCost, //原值
            salvage: row.salvage, //残值率
            salvageCost: this.salvageCostTotal(row), //残值

            oldTotalMoney: this.money(row) // 计折旧金额
          });
        })
        .catch(err => {
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error"
          });
          // this.$message.error("修改失败");
        });
    },
    //添加，编辑
    async handleEdit(index, row) {
      switch (row.edit) {
        case "保存":
          if (!row.id) {
            if (!row.fishBaseId || row.fishBaseId == "") {
              this.$message.error("请选择基地名称");
              return;
            }
            if (!row.typeId || row.typeId == "") {
              this.$message.error("请选择类型");
              return;
            }
            let nameReg = /^[\u4e00-\u9fa5a-zA-Z0-9]+$/;
            if (!nameReg.test(row.assetName) || row.assetName == "") {
              this.$message.error("请输入正确的资产名称且不为空");
              return;
            }
            let originalCostReg = /^[1-9]\d*$/;
            if (
              !originalCostReg.test(row.originalCost) ||
              row.originalCost == ""
            ) {
              this.$message.error("原值必须大于0且不为空");
              return;
            }
            let salvageReg = /^(0.\d+|0|1)$/;
            if (!salvageReg.test(row.salvage) || row.salvage === "") {
              this.$message.error("残值率范围：0-1且不为空");
              return;
            }
            if (row.satrtTime == "") {
              this.$message.error("请选择开始日期");
              return;
            }
            if (row.endTime == "") {
              this.$message.error("请选择结束日期");
              return;
            }
            // let oldTotalMonthReg = /^[1-9]\d*$/;
            // if (
            //   !oldTotalMonthReg.test(row.oldTotalMonth) ||
            //   row.oldTotalMonth == ""
            // ) {
            //   this.$message.error("总折旧月数必须大于0且不为空");
            //   return;
            // }
            if (row.provisionTime == "") {
              this.$message.error("请选择开始计提日期");
              return;
            }
            if (!row.ownerId || row.ownerId == "") {
              this.$message.error("请选择登记人");
              return;
            }
            this.addProductionPlan(index, row);
          } else {
            this.editProductionPlan(index, row);
          }

          break;
        case "编辑":
          this.baseList = await this.getBaseList();
          this.peopleList = await this.getEmployees();
          this.$set(this.list, index, {
            id: row.id,
            edit: "保存",
            fishBaseId: row.fishBaseId,
            typeId: row.typeId,
            ownerId: row.ownerId,
            assetName: row.assetName,
            satrtTime: row.satrtTime,
            endTime: row.endTime,
            oldTotalMonth: this.oldTotalMonthtotal(row), //总折旧月数
            dataDate: row.dataDate, //登记日期
            provisionTime: row.provisionTime, //开始计提日
            hasOldMonth: this.hasOldMonthTotal(row), //期初已折旧月数
            originalCost: row.originalCost, //原值
            salvage: row.salvage, //残值率
            salvageCost: this.salvageCostTotal(row), //残值

            oldTotalMoney: this.money(row) // 计折旧金额
          });
          this.$forceUpdate();
          break;
      }
    },
    //监听row值
    calculation(index, row) {
      this.$set(this.list, index, {
        id: row.id,
        edit: "保存",
        fishBaseId: row.fishBaseId,
        typeId: row.typeId,
        ownerId: row.ownerId,
        assetName: row.assetName,
        satrtTime: row.satrtTime,
        endTime: row.endTime,
        dataDate: row.dataDate, //登记日期
        oldTotalMonth: this.oldTotalMonthtotal(row), //总折旧月数
        provisionTime: row.provisionTime, //开始计提日
        hasOldMonth: this.hasOldMonthTotal(row), //期初已折旧月数
        originalCost: row.originalCost, //原值
        salvage: row.salvage, //残值率
        salvageCost: this.salvageCostTotal(row), //残值
        oldTotalMoney: this.money(row) // 计折旧金额
      });
    },
    //总折旧月数
    oldTotalMonthtotal(item) {
      console.log(67856, item.satrtTime, item.endTime);
      //用-分成数组
      if (item.satrtTime != "" && item.endTime != "") {
        let date1 = item.satrtTime.split("-");
        let date2 = item.endTime.split("-");
        //获取年,月数
        var year1 = parseInt(date1[0]);
        var month1 = parseInt(date1[1]);
        var year2 = parseInt(date2[0]);
        var month2 = parseInt(date2[1]);
        //通过年,月差计算月份差
        let result = (year2 - year1) * 12 + (month2 - month1) + 1;
        console.log(67856, result);
        return result;
      }
    },
    //计算残值--残值=原值*残值率；
    salvageCostTotal(item) {
      return (Number(item.originalCost) * Number(item.salvage)).toFixed(2);
    },
    //计算累计折旧（元）=原值*（1-残值率）/总折旧月数*累计折旧月数
    money(item) {
      let datas = this.hasOldMonthTotal(item);
      let data = (
        ((item.originalCost * (1 - item.salvage)) / item.oldTotalMonth) *
        datas
      ).toFixed(2);
      return data;
    },
    //计算期初已折旧月数=登记日-开始计提日
    hasOldMonthTotal(item) {
      console.log(11111, item.dataDate, item.provisionTime);

      if (item.dataDate != "" && item.provisionTime != "") {
        //用-分成数组
        let date1 = item.dataDate.split("-");
        let date2 = item.provisionTime.split("-");
        //获取年,月数
        var year1 = parseInt(date1[0]);
        var month1 = parseInt(date1[1]);
        var year2 = parseInt(date2[0]);
        var month2 = parseInt(date2[1]);
        //通过年,月差计算月份差
        let result = (year1 - year2) * 12 + (month1 - month2) + 1;
        console.log(989, result);

        return result;
      }
    },

    // 动态设置行的类名
    rowClassName(row) {
      if (row.row.edit == "编辑") {
        return "";
      } else {
        return "row-disabled";
      }
    },
    //添加
    async add() {
      if (this.once) {
        this.list.unshift({
          dataDate: this.$timeformatDay(new Date()),
          typeId: "",
          assetName: "",
          ownerId: "",
          originalCost: "",
          salvage: "",
          salvageCost: "",
          satrtTime: "",
          endTime: "",
          oldTotalMonth: "",
          provisionTime: "",
          hasOldMonth: "",
          oldTotalMoney: "",
          edit: "保存"
        });
        this.baseList = await this.getBaseList();
        this.peopleList = await this.getEmployees();
        this.once = false;
      } else {
        this.$Alert.info({
          content: "每次只能添加一条记录，请先保存",
          duration: 5000,
          status: "error"
        });
      }
    },

    // 删除
    handleDelete(index, row) {
      let pageIndex = this.pageInfo.pageNumber;
      if (this.pageInfo.totalPages % 10 === 1) {
        pageIndex -= 1;
      }
      this.$confirm("是否删除此记录", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        if (row.id) {
          this.deleteCostOriginValue(row.id)
            .then(data => {
              this.list.splice(index, 1);
              this.search(pageIndex);
              this.$message.success("删除成功");
              this.once = true;
            })
            .catch(err => {
              this.$Alert.info({
                content: err.response.data,
                duration: 5000,
                status: "error"
              });
            });
        } else {
          this.list.splice(index, 1);
          this.once = true;
        }
      });
    }
  }
};
</script>
<style lang="stylus">
  .costOriginValue
    .el-table .el-table__body tr.hover-row>td 
      background: none!important;
    .search-input
      text-align:left!important;
    .cell
      text-align:center;
      input
        text-align:center!important
      .el-input__suffix-inner
        pointer-events:none!important
        cursor: not-allowed!important
      td
        pointer-events:none!important
        cursor: not-allowed!important
        .el-input__inner
          border:none!important
    
    //去除table-hover
    .el-table tr:hover>td {
      background:none !important;
    }
    
    //去除type=number 输入款上下箭头
    input[type=number] {  
      -moz-appearance:textfield;  
    }  
    input[type=number]::-webkit-inner-spin-button,  
    input[type=number]::-webkit-outer-spin-button {  
        -webkit-appearance: none;  
        margin: 0;  
    }
    .el-tooltip
      input
        text-overflow: ellipsis;
    .el-date-editor.el-input .el-input__icon:before 
      content: '';
    .el-date-editor.el-input, .el-date-editor.el-input__inner
      width:85px!important;
      padding:0px;
    .el-input__inner
      padding:0;
      text-align: center;
    .content-edit,.content-del
      pointer-events:auto
    
    // 添加 row-disabled
    .row-disabled
   
      .el-icon-arrow-up:before
        content: "\E605"!important;
      td
        pointer-events:auto
        cursor: not-allowed
      .el-input__inner
        border:1px solid #ddd;
      .el-input--suffix
        .el-input__inner
          border:1px solid #ddd;
    
    .cell
      text-align:center;
      input
        text-align:center;
        
      .el-input__suffix-inner
        pointer-events:none
        cursor: not-allowed
    td
      pointer-events:none
      cursor: not-allowed
      .el-input__inner
        border:none
    
    .table-container
      .el-icon-arrow-up:before
        content: "";
      .el-input__inner
        background:initial;
        padding-right:0;
        padding-left:0;
    
</style>
